import { JsonObject, JsonProperty } from 'json2typescript';
import PutAllQuestionAnswerDetail from '@/models/entry/PutAllQuestionAnswerDetail';

@JsonObject('PutAllQuestionAnswer')
export default class PutAllQuestionAnswer {
  constructor() {
    this.questionCode = undefined;
    this.answers = [];
  }

  @JsonProperty('question_code')
  public questionCode?: string;

  @JsonProperty('answers', [PutAllQuestionAnswerDetail])
  public answers: PutAllQuestionAnswerDetail[];
}
